<template>
<div>
  <section>
    <TrackingPage/>
  </section>
  <InstructionsBar v-if="displayInstructionBar">
  </InstructionsBar>
</div>
</template>

<script>
import TrackingPage from "@/components/Notify/TrackingPage.vue";
import InstructionsBar from "@/components/InstructionsBar.vue";

export default {
  name: "Notify",
  props: ['displayInstructionBar'],
  components: {
    TrackingPage,
    InstructionsBar
  }
};
</script>

<style>
  section {
    padding-top: 60px;
    padding-bottom: 60px;
  }
</style>